// export const LOG_IN_REQUEST='LOG_IN_REQUEST'
// export const LOG_IN_SUCCESS='LOG_IN_SUCCESS'
// export const LOG_IN_FAILURE='LOG_IN_FAILURE'

// export const LOG_OUT_REQUEST='LOG_OUT_REQUEST'
// export const LOG_OUT_SUCCESS='LOG_OUT_SUCCESS'
// export const LOG_OUT_FAILURE='LOG_OUT_FAILURE'

// export const OTP_SEND_REQUEST='OTP_SEND_REQUEST'
// export const OTP_SEND_SUCCESS='OTP_SEND_SECCESS'
// export const OTP_SEND_FAILURE='OTP_SEND_FAILURE'

// export const USER_CHECK_REQUEST='USER_CHECK_REQUEST'

export const USER_CHECK_SUCCESS = 'USER_CHECK_SUCCESS'

export const CURRENT_MARKET_PRICE_REQUEST = 'CURRENT_MARKET_PRICE_REQUEST'

export const TRADE_HISTORY_REQUEST = 'TRADE_HISTORY_REQUEST'

export const LIMIT_ORDER_REQUEST = 'LIMIT_ORDER_REQUEST'


// export const USER_CHECK_FAILURE='USER_CHECK_FAILURE'

// export const LOGIN_CLICK='LOGIN_CLICK'



